import { debug } from 'application/Shared/Utils';

// Remove all images from localStorage.
function removeImageLocalStorageImages() {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i)?.startsWith('image_')) {
            debug.i('removing image', localStorage.key(i));
            localStorage.removeItem(localStorage.key(i) || '');
        }
    }
}

removeImageLocalStorageImages();
